
import React from 'react'
import Popup from '../Popup'
import BLOCKv from '../../Common/Blockv'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import swal from 'sweetalert'
import Errors from '../../Common/Errors'

export default class SetPasswordPopup extends Popup {

    constructor() {

        super()

        // Setup vars
        this.state = {}
        this.state.password1 = ''
        this.state.password1error = ''
        this.state.password2 = ''
        this.state.password2error = ''

    }

    render() {

        return <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', textAlign: 'center', overflowX: 'hidden', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>

            {/* Logo */}
            <div>
                <img src={require('./padlock.svg')} style={{ height: 128, margin: '40px 0px' }} />
            </div>

            {/* Title */}
            <div style={{ fontSize: 21, color: '#444', marginBottom: 10 }}>Set Password</div>
            <div style={{ fontSize: 15, color: '#444', margin: '0px 40px 40px 40px' }}>Enter your new password twice.</div>

            {/* Password fields */}
            <div style={{ padding: '0px 40px' }}>
                <TextField fullWidth variant="outlined" margin="dense" label={this.state.password1error || 'Enter password'} error={!!this.state.password1error} type="password" value={this.state.password1} onChange={e => this.setState({ password1: e.target.value, password1error: '' })} autoFocus />
                <TextField fullWidth variant="outlined" margin="dense" label={this.state.password2error || 'Repeat password'} error={!!this.state.password2error} type="password" value={this.state.password2} onChange={e => this.setState({ password2: e.target.value, password2error: '' })} />
            </div>

            {/* Buttons */}
            <div style={{ textAlign: 'center', margin: 20 }}>
                <Button variant="outlined" style={{ marginRight: 20 }} onClick={e => this.close()}>Cancel</Button>
                <Button variant="outlined" color="primary" onClick={e => this.save()}>Save</Button>
            </div>

        </div>

    }

    /** Save new password */
    save() {

        // Make sure passwords are ok
        if (this.state.password1.length < 4) return this.setState({ password1error: 'Too short' })
        if (this.state.password1 !== this.state.password2) return this.setState({ password2error: 'Did not match' })

        // Save password
        swal({ buttons: false, text: 'Saving password...' })
        BLOCKv.UserManager.updateUser({ password: this.state.password1 }).then(e => {

            // Success
            swal.close()
            this.close()

            // Show success
            swal('Password changed', 'Your password was changed successfully.', 'success')

            // Notify complete
            if (this.props.onComplete)
                this.props.onComplete()

        }).catch(err => {

            // Failed!
            swal.close()
            Errors.show(err)

        })

    }

}
